// removed by extract-text-webpack-plugin
module.exports = {"base":"Footer_base--3EEAC","base__edit":"Footer_base__edit--5ytuk","baseEdit":"Footer_base__edit--5ytuk","button":"Footer_button--mjCUZ","button__right":"Footer_button__right--3GqVT","buttonRight":"Footer_button__right--3GqVT","buttonText":"Footer_buttonText--krHy8"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/components/Footer/Footer.scss
// module id = 1364
// module chunks = 11